// ARCHIVO: src/App.jsx
// UBICACIÓN: C:\xampp\htdocs\react-migration\src\App.jsx
// DESCRIPCIÓN: Componente principal de la aplicación con navegación

import React, { useEffect, useState } from 'react'
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom'
import Dashboard from './pages/Dashboard'
import Productos from './pages/Productos'
import StockBajo from './pages/StockBajo'
import ProductosAgotados from './pages/ProductosAgotados'

import Ventas from './pages/Ventas'
import ReportesSimple from './pages/ReportesSimple'
import Estadisticas from './pages/Estadisticas'
import PerfilComercio from './pages/PerfilComercio'
import Ayuda from './pages/Ayuda'
import Layout from './components/Layout'
import ConsultaPrecioFloating from './components/ConsultaPrecioFloating'


function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isInitializing, setIsInitializing] = useState(false);
  const [showVencimientoPopup, setShowVencimientoPopup] = useState(false);
  const [diasRestantes, setDiasRestantes] = useState(null);
  const [tokenVencimiento, setTokenVencimiento] = useState(null);

  // Función para obtener token de la URL
  const getTokenFromUrl = () => {
    const urlParams = new URLSearchParams(location.search);
    return urlParams.get('token');
  };

  // Función para verificar vencimiento del token
  const verificarVencimientoToken = async (token) => {
    try {
      const response = await fetch(`https://www.sinfilas.com.ar/sf3/ventas/api/comercios_perfil_cargar.php?token=${token}&_t=${Date.now()}`);
      if (response.ok) {
        const data = await response.json();
        if (data.success && data.data && data.data.token_vencimiento) {
          const fechaVencimiento = new Date(data.data.token_vencimiento);
          const fechaActual = new Date();
          fechaActual.setHours(0, 0, 0, 0);
          fechaVencimiento.setHours(0, 0, 0, 0);
          const diferencia = fechaVencimiento.getTime() - fechaActual.getTime();
          const dias = Math.ceil(diferencia / (1000 * 60 * 60 * 24));
          
          setDiasRestantes(dias);
          setTokenVencimiento(data.data.token_vencimiento);
          
          // Si está vencido (≤ 0 días), cerrar ventana
          if (dias <= 0) {
            setTimeout(() => {
              window.close();
            }, 3000);
            return true; // Mostrar popup de bloqueo
          }
          
          // Si faltan 1-3 días, mostrar advertencia
          if (dias <= 3 && dias > 0) {
            return true; // Mostrar popup de advertencia
          }
        }
      }
    } catch (error) {
      console.error('Error verificando vencimiento:', error);
    }
    return false; // No mostrar popup
  };


  // Efecto para manejar la redirección del token
  useEffect(() => {
    const token = getTokenFromUrl();
    
    if (token) {
      console.log('🔒 [APP] Token detectado en URL, procesando encapsulado...');
      
      // Mostrar preload inmediatamente
      setIsInitializing(true);
      
      // Guardar token en localStorage y sessionStorage
      localStorage.setItem('comercio_token', token);
      sessionStorage.setItem('comercio_token_secure', token);
      
      // Limpiar URL INMEDIATAMENTE
      const cleanUrl = location.pathname;
      console.log('🔒 [APP] Limpiando URL de:', window.location.href, 'a:', cleanUrl);
      
      // Limpiar URL usando replaceState
      window.history.replaceState({}, document.title, cleanUrl);
      
      // Redirigir usando navigate para actualizar el estado de React Router
      navigate(cleanUrl, { replace: true });
      
      // Verificar que la URL se limpió correctamente
      setTimeout(() => {
        if (window.location.search.includes('token')) {
          console.warn('⚠️ [APP] La URL aún contiene el token, forzando limpieza...');
          window.history.replaceState({}, document.title, window.location.pathname);
        } else {
          console.log('✅ [APP] URL limpiada correctamente');
        }
      }, 100);
      
      // Ocultar preload después de un tiempo mínimo
      setTimeout(() => {
        setIsInitializing(false);
      }, 1000);
      
      // Verificar vencimiento del token
      verificarVencimientoToken(token).then((mostrarPopup) => {
        if (mostrarPopup) {
          setShowVencimientoPopup(true);
        }
      });
    } else {
      // Si no hay token en URL, asegurar que la aplicación se cargue normalmente
      console.log('🔒 [APP] No hay token en URL, cargando aplicación normalmente');
      setIsInitializing(false);
    }
  }, [location.search, navigate]);

  return (
    <div className="App">
          {/* Preload cuando se inicializa desde admin_comercio.php */}
          {isInitializing && (
            <div className="preload-overlay">
              <div className="preload-container">
                <img 
                  src="/sf3/ventas/logosinfilas.png" 
                  alt="SinFilas" 
                  className="preload-logo"
                />
                <div className="preload-spinner"></div>
                <div className="preload-text">Cargando Sistema de Ventas...</div>
              </div>
            </div>
          )}
      
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="productos" element={<Productos />} />
          <Route path="stock-bajo" element={<StockBajo />} />
          <Route path="agotados" element={<ProductosAgotados />} />

          <Route path="ventas" element={<Ventas />} />
          <Route path="reportes" element={<ReportesSimple />} />
          <Route path="estadisticas" element={<Estadisticas />} />
          <Route path="perfil-comercio" element={<PerfilComercio />} />
          <Route path="ayuda" element={<Ayuda />} />
        </Route>
      </Routes>

      {/* Popup de vencimiento del token */}
      {showVencimientoPopup && (
        <div className="vencimiento-popup-overlay">
          <div className="vencimiento-popup-container">
            <div className="vencimiento-popup-header">
              <img 
                src="/sf3/ventas/logosinfilas.png" 
                alt="SinFilas" 
                className="vencimiento-popup-logo"
              />
              <button 
                className="vencimiento-popup-close"
                onClick={() => setShowVencimientoPopup(false)}
              >
                ✕
              </button>
            </div>
            
            <div className="vencimiento-popup-content">
              {diasRestantes <= 0 ? (
                <div className="vencimiento-blocked">
                  <div className="vencimiento-icon">🚫</div>
                  <h2>Acceso Bloqueado</h2>
                  <p>Tu suscripción ha expirado. El sistema se cerrará automáticamente.</p>
                  <p className="vencimiento-fecha">
                    Fecha de vencimiento: {tokenVencimiento ? new Date(tokenVencimiento).toLocaleDateString('es-AR') : 'N/A'}
                  </p>
                </div>
              ) : (
                <div className="vencimiento-warning">
                  <div className={`vencimiento-icon ${diasRestantes === 1 ? 'blink' : ''}`}>⚠️</div>
                  <h2>Advertencia de Vencimiento</h2>
                  <p>
                    Te faltan <strong>{diasRestantes}</strong> {diasRestantes === 1 ? 'día' : 'días'} para actualizar tu suscripción.
                  </p>
                  <p>Si no actualizas tu suscripción, el sistema dejará de funcionar.</p>
                  <p className="vencimiento-fecha">
                    Fecha de vencimiento: {tokenVencimiento ? new Date(tokenVencimiento).toLocaleDateString('es-AR') : 'N/A'}
                  </p>
                </div>
              )}
            </div>
            
            <div className="vencimiento-popup-footer">
              <button 
                className="vencimiento-popup-button"
                onClick={() => setShowVencimientoPopup(false)}
              >
                {diasRestantes <= 0 ? 'Entendido' : 'Continuar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Botón flotante para consulta de precios */}
      <ConsultaPrecioFloating />
    </div>
  )
}

export default App